import { ClockCircleOutlined } from '@ant-design/icons';
import { UserMenuAccessibilityClassName } from '@framework/ui/components/button/UserButtonBase.tsx';
import { Drawer } from '@framework/ui/components/drawer/Drawer.tsx';
import { type MenuItemType } from 'antd/es/menu/interface';
import React, { useMemo } from 'react';
import { LastLoginDrawerContent } from './LastLoginDrawerContent.tsx';
import { LastLoginText } from './LastLoginText.tsx';
import { useLastLoginHistory } from './useLastLoginHistory.ts';

/**
 * Menu item per visualizzare l'ultimo accesso dell'utente
 */
export const useLastLoginMenuItem = () => {
  const { history, isLoading, error } = useLastLoginHistory();
  const [isOpen, setIsOpen] = React.useState(false);

  const lastLoginMenuItem = useMemo(
    () =>
      ({
        key: 'last-login-data',
        icon: <ClockCircleOutlined />,
        onClick: e => {
          setIsOpen(true);
          e.domEvent.preventDefault();
          e.domEvent.stopPropagation();
        },
        label: (
          <>
            <LastLoginText
              isLink={false}
              historyData={{ history, isLoading, error }}
            />
          </>
        ),
      }) as MenuItemType,
    [history, isLoading, error],
  );

  const lastLoginsDrawer = (
    <Drawer
      open={isOpen}
      onClose={e => {
        setIsOpen(false);
        (
          document.querySelector(
            `.${UserMenuAccessibilityClassName}`,
          ) as HTMLAnchorElement | null
        )?.focus();
      }}
      maskClosable={false}
      title="Elenco ultimi 10 accessi"
      placement="right"
      size="large"
    >
      <LastLoginDrawerContent historyData={{ history, isLoading, error }} />
    </Drawer>
  );

  return { lastLoginMenuItem, lastLoginsDrawer };
};
